import { useQuery } from '@tanstack/react-query';
import { getMemberOverrides, getUserPermissions } from '../services/permission.service';
import { conversationKeys } from './conversation-keys';

/**
 * Fetch current user's permissions for a conversation
 * Lazy loads when convId is provided
 */
export const useUserPermissions = (convId?: Nullable<string>) => {
  return useQuery({
    queryKey: conversationKeys.permissions(convId!),
    queryFn: () => getUserPermissions(convId!),
    enabled: !!convId,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
};

/**
 * Fetch permission overrides for a specific member
 * Used by admins to view/edit member permissions
 */
export const useMemberOverrides = (convId: string, memberId?: Nullable<string>) => {
  return useQuery({
    queryKey: conversationKeys.memberOverrides(convId, memberId!),
    queryFn: () => getMemberOverrides(convId, memberId!),
    enabled: !!convId && !!memberId,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
};
